import { CompanyEmployeeWithSubsidyAmount } from '@app/@graphql';
import { Observable } from 'rxjs';

export abstract class EmployeesData {
    abstract getNoOrdersEmployeesTableData(): Observable<CompanyEmployeeWithSubsidyAmount[]>;
}